import { Construction } from 'lucide-react'
import EmptyState from '@/components/empty-state'
import styles from './style.module.css'

interface PendingModuleProps {
  descricao: string
  dependencias: string[]
  card?: string
}

const PendingModule = ({ card, dependencias, descricao }: PendingModuleProps) => (
  <div className={styles.wrapper}>
    <EmptyState
      icon={<Construction size={28} />}
      title="Módulo ainda não disponível"
      description={descricao}
    />

    <div className={styles.detalhe}>
      <span className={styles.titulo}>O que falta para esta tela funcionar</span>
      <ul className={styles.lista}>
        {dependencias.map((dependencia) => (
          <li key={dependencia}>{dependencia}</li>
        ))}
      </ul>
      {card ? <span className={styles.card}>Acompanhe em {card}</span> : null}
    </div>
  </div>
)

export default PendingModule
